import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ChatMessageComponent } from '../chat-message/chat-message.component';
import { MessageDatePipe } from '../../../../pipes/date.pipe';

@Component({
  standalone: true,
  selector: 'user-chat-message',
  templateUrl: './user-chat-message.component.html',
  styleUrl: './user-chat-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChatMessageComponent, MessageDatePipe],
})
export class UserChatMessageComponent {
  text = input.required<string>();
  time = input.required<string>();
}
